export enum FilterByDate {
  AllTime = 'AllTime',
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'ThisWeek',
  Last14Day = 'Last14Day',
  LastMonth = 'LastMonth',
  LastYear = 'LastYear'
}
